/* eslint-disable */
import { fromUrl } from "geotiff";
export default class imageHistogram {
    constructor() {
    }

    // /**
    //  * @name: 
    //  * @msg: 
    //  * @param {*} url 影像地址
    //  * @param {*} bandIndex 波段索引
    //  * @return {*}
    //  */
    // async quantileClassification(url, bandIndex) {
    //     const tiff = await fromUrl(url);
    //     const image = await tiff.getImage();

    //     //波段统计（暂时无用）
    //     const bands = [];
    //     const samples = image.getSamplesPerPixel();
    //     for (let i = 0; i < samples; i++) {
    //         const element = image.getGDALMetadata(i);
    //         bands.push(element);
    //     }

    //     //获取nodata ，遇到nodata则跳过不做统计
    //     let noData = image.getGDALNoData();
    //     noData = noData ? noData : 0;

    //     // 统计最值
    //     let min, max, range;
    //     let count = 0; //有效像元数
    //     const data = await tiff.readRasters();
    //     data[bandIndex].forEach((v) => {
    //         if (v !== noData) {
    //             if (!min) min = v;
    //             if (!max) max = v;
    //             if (min > v) min = v;
    //             if (max < v) max = v;
    //             count++;
    //         }
    //     });
    //     range = max - min;

    //     //统计直方图
    //     let xCount = 255;
    //     let hisΔx = range / (xCount);
    //     //此种计算方法 最大值正好落在第xCount+1的地方，导致输出直方图列数+1。
    //     let histogram = new Array(xCount + 1).fill(0);
    //     data[bandIndex].forEach((v) => {
    //         if (v !== noData) {
    //             let index = Math.floor((v - min) / hisΔx);
    //             histogram[index] += 1;
    //         }
    //     });
    //     xCount++;
    //     // console.log(histogram,count);

    //     //计算分类区间 直方图x轴为栅格值 y轴为栅格数量
    //     let classificationCount = 5;
    //     let singleClassCount = Math.ceil(count / classificationCount);
    //     let classification = [];
    //     let hisΣy = 0;
    //     let hisx_index = 0; //从0开始目的是为了给hisΣy赋初始值
    //     for (let classIndex = 0; classIndex < classificationCount; classIndex++) {
    //         for (hisx_index; hisx_index < xCount; hisx_index++) {
    //             let targetΣy = (classIndex + 1) * singleClassCount;
    //             let y = histogram[hisx_index];
    //             let x = hisx_index * hisΔx;
    //             if (hisΣy < targetΣy) {//累计值小于所需值跳过
    //                 hisΣy += y;
    //             }
    //             else if (hisΣy == targetΣy) {//累计值等于所需值，说明分割点在直方图分割的值上
    //                 classification.push(x);
    //                 hisΣy += y;
    //                 break;
    //             }
    //             else {//累计值大于所需值，说明分割点在直方图中
    //                 let hisΣy1 = hisΣy - histogram[hisx_index - 1];
    //                 let Δy = targetΣy - hisΣy1;
    //                 let k = Δy / y;
    //                 let Δx = k * hisΔx;
    //                 classification.push(Δx + x);
    //                 //防止还有分割点落在其中所以在循环一遍
    //                 hisx_index--;
    //                 break;
    //             }
    //         }
    //     }
    //     console.log(histogram,min, max, classification);
    //     classification.forEach(v => {
    //         console.log((v - min) / range);
    //     });
    //     // histogram.forEach((v, i) => {
    //     //     hisΣy += v;//直方图累加
    //     //     let target_hisΣy = singleClassCount * (classIndex + 1); //分类所需数量
    //     //     if (hisΣy < target_hisΣy) return; //此时直方图累加小于分类所需数量 直接跳过
    //     //     else //此时直方图累加大于等于类所需数量 说明分割点落在该直方图内（一个或多个）
    //     //     {
    //     //         let hisy_last = hisΣy - v;
    //     //         let hisΔy = target_hisΣy - hisy_last;
    //     //         let k = hisΔy / v; //获得y比率
    //     //         let hisx = i * hisΔ;
    //     //         classification.push(hisx + hisΔ * k);//根据比率求出分割点


    //     //     }

    //     // })
    //     return { noData, bands, min, max, range };
    // }

    /**
     * @name: 分位数分类
     * @msg: 
     * @param {*} url 影像地址
     * @param {*} bandIndex 运算波段 默认0
     * @param {*} classificationCount 分类数量 传入数量为实际数量+1
     * @return {*}
     */
    async quantileClassification(url, bandIndex = 0, classificationCount = 6) {
        const tiff = await fromUrl(url.replace(/.tif$/, "_2.tif"));
        const image = await tiff.getImage();

        //波段统计（暂时无用）
        const bands = [];
        const samples = image.getSamplesPerPixel();
        for (let i = 0; i < samples; i++) {
            const element = image.getGDALMetadata(i);
            bands.push(element);
        }

        //获取nodata ，遇到nodata则跳过不做统计
        let noData = image.getGDALNoData();
        noData = noData ? noData : 0;

        const data = await tiff.readRasters();

        let sortAns = data[bandIndex].filter(v => {
            return v != noData
        }).sort();
        let Δ = Math.floor(sortAns.length / classificationCount);
        let min = sortAns[0], max = sortAns[sortAns.length - 1];
        let classification = [];
        for (let classIndex = 0; classIndex < classificationCount; classIndex++) {
            if (classIndex == 0) classification.push(min);
            else if (classIndex == classificationCount - 1) classification.push(max);
            else classification.push(sortAns[Δ * (classIndex + 1)]);
        }
        let classification1 = classification.map(e=>{
            return (e - min) / (max - min);
        });
        return classification1;
    }

}